var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatherUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feather:upload-cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.5 32.5L24.5 24.5L16.5 32.5",
    stroke: "#026735",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.5 24.5V42.5",
    stroke: "#026735",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.2799 37.28C43.2306 36.2165 44.7716 34.5337 45.6597 32.4972C46.5477 30.4607 46.7323 28.1864 46.1843 26.0334C45.6363 23.8803 44.3869 21.971 42.6333 20.6069C40.8796 19.2427 38.7216 18.5014 36.4999 18.5H33.9799C33.3745 16.1585 32.2462 13.9846 30.6798 12.142C29.1134 10.2993 27.1496 8.83567 24.9361 7.86118C22.7226 6.8867 20.317 6.42669 17.9002 6.51573C15.4833 6.60478 13.1181 7.24057 10.9823 8.3753C8.84649 9.51003 6.99574 11.1142 5.56916 13.0671C4.14259 15.0201 3.1773 17.271 2.74588 19.6508C2.31446 22.0305 2.42813 24.477 3.07835 26.8065C3.72856 29.136 4.8984 31.2877 6.49992 33.1",
    stroke: "#026735",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.5 32.5L24.5 24.5L16.5 32.5",
    stroke: "#026735",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherUploadCloud);
export default __webpack_public_path__ + "static/media/feather_upload-cloud.54cc2c38ea6a6925544f1043123b7309.svg";
export { ForwardRef as ReactComponent };